import React from 'react';
import './EmployeeShortReport.css';
import TopToolbar from '../../global/subcomponents/topToolbar/TopToolbar';
import FeedbackBar from '../../feedbackBar/FeedbackBar';
import withShipment from '../../../withShipment';
import {
  employeesSelector,
  userInfoSelector,
} from '../../../redux/selectors/auth';
import { loadingSelector } from '../../../redux/selectors/settings';

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import InputAdornment from '@material-ui/core/InputAdornment';
import { employeeLoanSelector } from '../../../redux/selectors/loan';

import {
  CardContent,
  Typography,
  IconButton,
  Collapse,
  Divider,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getEmployees } from '../../../redux/actions/auth';
import {
  listEmployeeLoan,
  saveEmployeeLoan,
} from '../../../redux/actions/loan';

class EmployeeShortReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      feedbackBarOpen: false,
      feedbackMessage: '',
      feedbackStatus: '',
      selectedEmployeeId: null,
      amountInput: '',
      dateInput: new Date().toISOString().split('T')[0],
      shortHistory: {},
      displayOrder: [],
      expanded: {},
      selectedType: null,
    };
    this.colorMap = {};
  }

  componentDidMount() {
    this.props.getEmployees({
      locationId: this.props.userInfo.selectedLocationId,
    });
    this.props.listEmployeeLoan({
      locationId: this.props.userInfo.selectedLocationId,
      userId: this.props.userInfo.userId,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.employeeShortHistory !== this.props.employeeShortHistory) {
      const shortHistoryObj = {};

      this.props.employeeShortHistory.forEach((loan) => {
        shortHistoryObj[loan.employeeLoanId] = (loan.shortHistory || []).map(
          (entry) => ({
            ...entry,
            transactionId: entry.transactionId || null,
          })
        );
      });

      this.setState({
        shortHistory: shortHistoryObj,
      });
    }
  }

  toggleExpand = (custId) => {
    this.setState((prev) => ({
      expanded: {
        ...prev.expanded,
        [custId]: !prev.expanded[custId],
      },
    }));
  };

  userIsAnAdmin = () => {
    const { userInfo } = this.props;
    const roles = userInfo?.authority || [];
    return roles.includes('ROLE_ADMIN') || roles.includes('ROLE_MASTER_ADMIN');
  };

  getColorForEmployee(custId) {
    if (!this.colorMap[custId]) {
      this.colorMap[custId] = this.getRandomLightColor();
    }
    return this.colorMap[custId];
  }

  openFeedbackBar = (status, message) => {
    this.setState({
      feedbackStatus: status,
      feedbackMessage: message,
      feedbackBarOpen: true,
    });
  };

  closeFeedbackBar = () => {
    this.setState({
      feedbackBarOpen: false,
      feedbackStatus: '',
      feedbackMessage: '',
    });
  };

  handleEmployeeChange = (event, newValue) => {
    this.setState({
      selectedEmployeeId: newValue ? newValue.userId : null,
    });
  };

  handleDateChange = (date) => {
    if (date && date.toString() !== 'Invalid Date') {
      // format to yyyy-MM-dd string for your existing code logic (optional)
      const formattedDate = date.toISOString().split('T')[0];
      this.setState({ dateInput: formattedDate });
    } else {
      this.setState({ dateInput: '' });
    }
  };

  handleAddTransaction = () => {
    const {
      amountInput,
      dateInput,
      selectedEmployeeId,
      shortHistory,
      selectedType,
    } = this.state;

    if (!selectedEmployeeId) {
      this.openFeedbackBar('error', 'Please select an employee');
      return;
    }

    if (!selectedType) {
      this.openFeedbackBar('error', 'Please select a type');
      return;
    }

    if (!amountInput || isNaN(amountInput) || parseFloat(amountInput) <= 0) {
      this.openFeedbackBar(
        'error',
        'Please enter a valid amount greater than 0'
      );
      return;
    }

    if (!dateInput) {
      this.openFeedbackBar('error', 'Please select a date');
      return;
    }

    const employee = this.props.employees.find(
      (c) => c.userId === selectedEmployeeId
    );

    // Prepare the new transaction
    let amount = parseFloat(amountInput);
    if (selectedType.toUpperCase() === 'SUBTRACT') {
      amount = -amount;
    }

    const newTransaction = {
      firstName: employee.firstname,
      lastName: employee.lastname,
      amount,
      date: dateInput,
      type: selectedType,
      employeeName: this.props.userInfo?.firstname,
    };

    // Add new transaction to shortHistory
    const updatedHistory = {
      ...shortHistory,
      [selectedEmployeeId]: [
        newTransaction,
        ...(shortHistory[selectedEmployeeId] || []),
      ],
    };

    // Build new display order
    const allEmployeeIds = this.props.employees.map((c) => c.userId);
    const newDisplayOrder = [
      selectedEmployeeId,
      ...allEmployeeIds.filter((id) => id !== selectedEmployeeId),
    ];

    // Call backend with updatedHistory
    const callback = (error, response) => {
      if (error) {
        this.openFeedbackBar('error', error);
      } else {
        this.setState({
          shortHistory: updatedHistory,
          displayOrder: newDisplayOrder,
          amountInput: '',
          dateInput: new Date().toISOString().split('T')[0],
        });

        this.openFeedbackBar('success', response);
      }
    };

    this.props.saveEmployeeLoan(
      {
        shortHistory: updatedHistory,
        locationId: this.props.userInfo.selectedLocationId,
      },
      callback
    );
  };

  getEmployeeBalance = (employeeId) => {
    const history = this.state.shortHistory[employeeId] || [];
    return history.reduce((acc, t) => acc + t.amount, 0);
  };

  getRandomLightColor() {
    const r = Math.floor(Math.random() * 25) + 230; // 230-255
    const g = Math.floor(Math.random() * 25) + 230;
    const b = Math.floor(Math.random() * 25) + 230;
    return `rgb(${r}, ${g}, ${b})`;
  }

  render() {
    const { dateInput, displayOrder, shortHistory } = this.state;

    const orderedEmployees =
      displayOrder.length > 0
        ? displayOrder
        : this.props.employees.map((c) => c.userId);

    return (
      <React.Fragment>
        <TopToolbar
          pageName="Employee Short Report"
          // menuItems={this.getContextualMenuItems()}
        />

        <div className="loan-container">
          {/* Add Transaction Form */}

          {this.userIsAnAdmin() && (
            <div className="loan-form">
              <div className="form-row">
                <Autocomplete
                  className="form-input"
                  options={
                    Array.isArray(this.props.employees)
                      ? this.props.employees
                      : [this.props.employees]
                  }
                  getOptionLabel={(option) =>
                    [option.firstname, option.lastname]
                      .filter(Boolean)
                      .join(' ')
                  } // ✅ filter(Boolean) removes undefined or empty
                  value={
                    this.state.selectedEmployeeId
                      ? this.props.employees.find(
                          (c) => c.userId === this.state.selectedEmployeeId
                        ) || null
                      : null
                  }
                  onChange={this.handleEmployeeChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      name="employee"
                      label="Select Employee"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                  filterOptions={(options, { inputValue }) => {
                    return options.filter((c) => {
                      const fullName = [c.firstname, c.lastname]
                        .filter(Boolean)
                        .join(' ')
                        .toLowerCase();
                      return fullName.includes(inputValue.toLowerCase());
                    });
                  }}
                  clearOnEscape
                />

                <Autocomplete
                  className="form-input"
                  options={['ADD', 'SUBTRACT']}
                  value={this.state.selectedType || null}
                  onChange={(event, newValue) => {
                    this.setState({ selectedType: newValue });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      name="type"
                      label="Select Type"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                  clearOnEscape
                />

                <TextField
                  className="form-input"
                  variant="outlined"
                  label="Amount"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                  name="amount"
                  required
                  value={this.state.amountInput}
                  onChange={(e) => {
                    // Only allow digits and optional decimal point
                    const value = e.target.value;
                    const sanitizedValue = value.replace(/[^0-9.]/g, '');
                    this.setState({ amountInput: sanitizedValue });
                  }}
                  type="text" // keep as text to fully control input
                  onBlur={() => {
                    let val = parseFloat(this.state.amountInput);
                    if (isNaN(val) || val < 0) val = 0;
                    this.setState({ amountInput: val.toFixed(2) });
                  }}
                />

                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    className="form-input"
                    autoOk
                    name="toDate"
                    variant="inline"
                    inputVariant="outlined"
                    label="Date"
                    format="yyyy-MM-dd"
                    required
                    InputAdornmentProps={{ position: 'start' }}
                    value={dateInput ? new Date(dateInput) : null}
                    onChange={this.handleDateChange}
                  />
                </MuiPickersUtilsProvider>

                <button
                  onClick={this.handleAddTransaction}
                  className="loan-btn"
                >
                  Add
                </button>
              </div>
            </div>
          )}

          {/* All Employees Loan History */}

          {(!this.props.employeeShortHistory ||
            this.props.employeeShortHistory.length === 0) && (
            <div className="no-history-container">
              <CardContent className="no-history-card">
                <div className="no-history-icon">
                  <span role="img" aria-label="empty">
                    📄
                  </span>
                </div>
                <Typography variant="h6" className="no-history-title">
                  No Employee Short Added Yet
                </Typography>
                <span className="no-history-subtitle">
                  Once you add a record, it will appear here.
                </span>
              </CardContent>
            </div>
          )}

          <div className="loan-history-card-container">
            {orderedEmployees.map((userId) => {
              const user = this.props.employees.find(
                (c) => c.userId === userId
              );
              if (!user) return null;

              const history = shortHistory[userId] || [];
              if (history.length === 0) return null;

              const balance = this.getEmployeeBalance(userId);
              const isExpanded = this.state.expanded[userId] || false;

              return (
                <div
                  key={userId}
                  className="note-card-loan"
                  style={{ backgroundColor: this.getColorForEmployee(userId) }}
                >
                  {/* Employee Name */}
                  <CardContent className="">
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Typography variant="h6" className="customer-name">
                        {user.firstname} {user.lastname}
                      </Typography>

                      <IconButton
                        onClick={() => this.toggleExpand(userId)}
                        className="toggle-btn"
                        size="small"
                      >
                        {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                      </IconButton>
                    </div>
                  </CardContent>

                  <Divider className="thin-divider" />

                  {/* Transactions List */}
                  <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                    <CardContent className="transactions-list">
                      <List dense>
                        {history.map((t, i) => (
                          <ListItem key={i}>
                            <ListItemText
                              primary={
                                <span>
                                  <span
                                    style={{
                                      fontSize: '1.2em',
                                      color: t.amount < 0 ? 'red' : 'green',
                                      fontWeight: 'bold',
                                    }}
                                  >
                                    {`${t.amount < 0 ? '-' : '+'}$${Math.abs(
                                      t.amount
                                    )}`}
                                  </span>{' '}
                                  <span
                                    style={{
                                      color: 'gray',
                                      fontSize: '0.85em',
                                    }}
                                  >
                                    — {t.date} —{' '}
                                    <span style={{ fontStyle: 'italic' }}>
                                      {t.employeeName}
                                    </span>
                                  </span>
                                </span>
                              }
                            />
                          </ListItem>
                        ))}
                      </List>
                    </CardContent>
                  </Collapse>

                  {/* Balance */}
                  <CardContent className="balance-section">
                    <Typography
                      variant="h6"
                      style={{ fontSize: '16px', fontWeight: 'bold' }}
                      className={
                        balance < 0 ? 'amount-negative' : 'amount-positive'
                      }
                    >
                      Balance{': '}
                      {balance < 0
                        ? `- $${Math.abs(balance).toFixed(2)}`
                        : `$${balance.toFixed(2)}`}
                    </Typography>
                  </CardContent>
                </div>
              );
            })}
          </div>
        </div>

        <FeedbackBar
          open={this.state.feedbackBarOpen}
          handleClose={this.closeFeedbackBar}
          severity={this.state.feedbackStatus}
          message={this.state.feedbackMessage}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  userInfo: userInfoSelector(state),
  loadingData: loadingSelector(state),
  employees: employeesSelector(state),
  employeeShortHistory: employeeLoanSelector(state),
});

const actionCreators = {
  getEmployees,
  saveEmployeeLoan,
  listEmployeeLoan,
};

export default withShipment(
  { actionCreators, mapStateToProps },
  EmployeeShortReport
);
